import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'
import { useTranslaterStore } from '@/stores/translater'

export const useFavoriteCarsStore = defineStore('favoritesCars', () => {

    const favoriteCars              = ref({})
    const favoriteCarsProcess       = ref(false)
    const favoriteCarsMsg           = ref({})
    const favoriteCarCreateProcess  = ref(false)
    const favoriteCarCreateMsg      = ref({})
    const favoriteCarDeleteProcess  = ref(false)
    const favoriteCarDeleteMsg      = ref({})

    const tokenStore    = useTokenStore()
    const requestsStore = useRequestsStore()
    const configStore   = useConfigStore()
    const getTranslate  = useTranslaterStore().getTranslate

    /**
     * Создаёт новый автомобиль
     * 
     * @param {Object} payload - объект с полями формы создания нового автомобиля
     */
    async function createFavoriteCar(payload) {

        const token = tokenStore.access

        if(token) {

            favoriteCarCreateProcess.value = true

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars/favorites`, 
                method: 'POST', 
                token,
                data: payload
            })

            if(!request.error) {

                favoriteCars.value = request
                favoriteCarCreateMsg.value = { success: true, text: getTranslate.FAVORITE_CARS_CREATE_SUCCESS }

            } else {

                favoriteCarCreateMsg.value = { success: false }
                favoriteCarCreateMsg.value.text = getTranslate[request.error] || request.error
            }

            favoriteCarCreateProcess.value = false

            return request

        } else {

            favoriteCarCreateMsg.value = { success: false, text:getTranslate.EUnauthRequest }
        }
    }

    /**
     * Получает избранные автомобили
     * 
     * @param {String} payload - параметры запроса [см.swagger]
     */
    async function readFavoriteCars(payload) {

        const token = tokenStore.access

        if(token) {

            favoriteCarsProcess.value = true

            let params = ''

            if(payload) {

                for( let param in payload) {

                    if(typeof payload[param] == 'object' && payload[param].length) {

                        payload.uuidCarArray.map( el => {

                            params.length ?
                                params += '&' + param + '=' + el :
                                params = '?' + param + '=' + el
                        })

                    } else {

                        params.length ?
                            params += '&' + param + '=' + payload[param] :
                            params = '?' + param + '=' + payload[param]
                    }
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars/favorites${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {

                favoriteCars.value = request
                favoriteCarsMsg.value = { success: true }

                return request

            } else {

                favoriteCars.value = { array: [] }
                favoriteCarsMsg.value = { success: false }
                favoriteCarsMsg.value.text = getTranslate[request.error] || request.error
            }

            favoriteCarsProcess.value = false

        } else {

            favoriteCarsMsg.value = { success: false, text: getTranslate.EUnauthRequest }
        }

        return false
    }

    /**
     * Удаляет автомобили
     * 
     * @param {String} payload - UUID автомобиля
     */
    async function deleteFavoriteCar(payload) {

        const token = tokenStore.access

        if(token) {

            favoriteCarDeleteProcess.value = true

            let params = ''

            if(payload) {

                for( let param in payload) {

                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars/favorites${params}`, 
                method: 'DELETE', 
                token
            })

            if(!request.error) {

                favoriteCars.value = request
                favoriteCarDeleteMsg.value = { success: true, text: getTranslate.FAVORITE_CARS_DELETE_SUCCESS } 

            } else {

                favoriteCars.value = { array: [] }
                favoriteCarDeleteMsg.value = { success: false }
                favoriteCarDeleteMsg.value.text = getTranslate[request.error] || request.error
            }

            favoriteCarDeleteProcess.value = false

            return request

        } else {

            favoriteCarDeleteMsg.value = { success: false, text: getTranslate.EUnauthRequest }
        }
    }

    const setFavoriteCarsMsg        = data => favoriteCarsMsg.value      = data
    const setDeleteFavoriteCarMsg   = data => favoriteCarDeleteMsg.value = data
    const setCreateFavoriteCarMsg   = data => favoriteCarCreateMsg.value = data

    return {

        favoriteCars,
        favoriteCarsProcess,
        favoriteCarsMsg,
        favoriteCarCreateProcess,
        favoriteCarCreateMsg,
        favoriteCarDeleteProcess,
        favoriteCarDeleteMsg, 
        createFavoriteCar, 
        readFavoriteCars, 
        deleteFavoriteCar, 
        setFavoriteCarsMsg, 
        setCreateFavoriteCarMsg, 
        setDeleteFavoriteCarMsg
    }
})